import { useContext } from 'react'

import { Box, Spinner, Text } from '@fairfashion/design-system'

import { BackButton } from '../../components/BackButton/back-button.comp'
import { ProvidersMap } from '../../components/ProvidersMap/providers-map.comp'

import { ProviderInfo } from './components/ProviderInfo/provider-info.comp'
import { ProviderList } from './components/ProviderList/provider-list.comp'
import { ProviderResumeCards } from './components/ProviderResumeCards/provider-resume-cards.comp'
import { ProviderRisksCard } from './components/ProviderRisksCard/provider-risks-card.comp'
import { ProviderTabs } from './components/ProviderTabs/provider-tabs.comp'
import { ProviderContext, ProviderProvider } from './provider.context'

const ProviderComp = () => {
  const { loading, data } = useContext(ProviderContext)

  return !loading ? (
    <Box width="100%" direction="column" gap={3} padding={3}>
      <Box alignItems="center" gap={2}>
        <BackButton url="/providers/" />
        <Text color="grey_3" size="small">
          Atenção: certifique-se de salvar antes de sair, caso contrário seus
          dados serão perdidos.
        </Text>
      </Box>
      {data ? (
        <>
          <Box
            width="100%"
            height="100%"
            gap={3}
            flexWrap="wrap"
            alignItems="stretch"
          >
            <Box
              flex={1}
              direction="column"
              gap={3}
              maxWidth="460px"
              width="100%"
            >
              <Box
                width="100%"
                flex={1}
                flexWrap="wrap"
                alignItems="stretch"
                gap={3}
              >
                <ProviderInfo />
              </Box>
              <ProviderResumeCards />
            </Box>
            <Box flex={1} flexWrap="wrap" gap={3}>
              <ProviderRisksCard />
              <ProviderList />
            </Box>
          </Box>
          <ProvidersMap providerId={data?.id} />
          <ProviderTabs />
        </>
      ) : (
        <Box
          width="100%"
          height="50vh"
          alignItems="center"
          justifyContent="center"
        >
          Não há dados para esse fornecedor
        </Box>
      )}
    </Box>
  ) : (
    <Box
      width="100%"
      height="100%"
      padding={3}
      alignItems="center"
      justifyContent="center"
    >
      <Spinner size="40px" />
    </Box>
  )
}
export const Provider = () => {
  return (
    <ProviderProvider>
      <ProviderComp />
    </ProviderProvider>
  )
}
